import { useState } from 'react';
import NullCheckUtil from '../util/NullCheckUtil';

const PasswordInputBox = ({
    size,
    disabled = false,
    setPassword,
    setIsPassword,
    setPasswordConfirm,
    setIsPasswordConfirm,
}) => {
    const [passwordMessage, setPasswordMessage] = useState('');
    const [passwordConfirmMessage, setPasswordConfirmMessage] = useState('');
    const [passwordCurrent, setPasswordCurrent] = useState('');
    const [passwordConfirmCurrent, setPasswordConfirmCurrent] = useState('');
    const [isSafePassword, setIsSafePassword] = useState(false);
    const [isSafePasswordConfirm, setIsSafePasswordConfirm] = useState(false);

    const onChangePassword = (newValue) => {
        setPasswordCurrent(newValue);
        setPassword(newValue);
        validatePassword(newValue);
        diffPassword(newValue, passwordConfirmCurrent);
    };

    const onChangePasswordConfirm = (newValue) => {
        setPasswordConfirmCurrent(newValue);
        setPasswordConfirm(newValue);
        diffPassword(passwordCurrent, newValue);
    };

    const validatePassword = (passwordCurrent) => {
        const passwordRegex = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{9,25}$/;
        if (!passwordRegex.test(passwordCurrent)) {
            setPasswordMessage('숫자+영문자+특수문자 조합으로 9자리 이상 입력해주세요.');
            setIsSafePassword(false);
            setIsPassword(false);
        } else {
            setPasswordMessage('안전한 비밀번호 입니다.');
            setIsSafePassword(true);
            setIsPassword(true);
        }
    };

    const diffPassword = (passwordCurrent, passwordConfirmCurrent) => {
        if (NullCheckUtil.isNotEmpty(passwordConfirmCurrent)) {
            if (passwordCurrent !== passwordConfirmCurrent) {
                setPasswordConfirmMessage('비밀번호가 일치하지 않습니다.');
                setIsSafePasswordConfirm(false);
                setIsPasswordConfirm(false);
            } else {
                setPasswordConfirmMessage('비밀번호가 일치 합니다.');
                setIsSafePasswordConfirm(true);
                setIsPasswordConfirm(true);
            }
        }
    };

    return (
        <>
            <div
                className={
                    'form-box' +
                    (size != undefined
                        ? size == 'small'
                            ? ' w-sm'
                            : size == 'medium'
                            ? ' w-md'
                            : size == 'w-420'
                            ? ' w-420'
                            : ' w-lg'
                        : '')
                }
            >
                <div className='input-box'>
                    <label htmlFor='비밀번호'>비밀번호</label>
                    <div className='input-group'>
                        <input
                            id='비밀번호'
                            type='password'
                            className='form-control '
                            disabled={disabled}
                            value={passwordCurrent == undefined || passwordCurrent == null ? '' : passwordCurrent}
                            onChange={(e) => onChangePassword(e.target.value)}
                        />
                    </div>
                </div>
                <p className={isSafePassword ? 'find-blue-txt' : 'find-red-txt'}>{passwordMessage}</p>
            </div>
            <div
                className={
                    'form-box' +
                    (size != undefined
                        ? size == 'small'
                            ? ' w-sm'
                            : size == 'medium'
                            ? ' w-md'
                            : size == 'w-420'
                            ? ' w-420'
                            : ' w-lg'
                        : '')
                }
            >
                <div className='input-box'>
                    <label htmlFor='비밀번호 확인'>비밀번호 확인</label>
                    <div className='input-group'>
                        <input
                            id='비밀번호 확인'
                            type='password'
                            className='form-control '
                            disabled={disabled}
                            value={
                                passwordConfirmCurrent == undefined || passwordConfirmCurrent == null
                                    ? ''
                                    : passwordConfirmCurrent
                            }
                            onChange={(e) => onChangePasswordConfirm(e.target.value)}
                        />
                    </div>
                </div>
                <p className={isSafePasswordConfirm ? 'find-blue-txt' : 'find-red-txt'}>{passwordConfirmMessage}</p>
            </div>
        </>
    );
};

export default PasswordInputBox;
